/**
 * Chains product add-on checkboxes (snippets/product-addons.liquid) and variant add-on
 * rows (snippets/variant-addons.liquid) after the main line is added to the cart.
 *
 * - PDP: listens for variant:add (dispatched on the product form by theme product-form).
 * - Collection quick-add: listens for product:added (dispatched from custom.js addItemToCart).
 */
(function () {
  'use strict';

  function cartAddJsUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    if (!r || r === '/') return '/cart/add.js';
    return r.replace(/\/?$/, '/') + 'cart/add.js';
  }

  function collectAddonVariantIds(scope) {
    var seen = {};
    var ids = [];

    function add(raw) {
      var id = parseInt(String(raw), 10);
      if (!Number.isFinite(id) || id <= 0) return;
      if (seen[id]) return;
      seen[id] = true;
      ids.push(id);
    }

    if (!scope || !scope.querySelectorAll) return ids;

    scope.querySelectorAll('.addon_add:checked').forEach(function (el) {
      if (el.disabled) return;
      var v = el.value;
      if (v && String(v).toLowerCase() !== 'none') add(v);
    });

    scope.querySelectorAll('.variant-list-container[data-selected]').forEach(function (el) {
      var ds = el.getAttribute('data-selected');
      if (!ds || ds === 'none' || ds === '') return;
      add(ds);
    });

    return ids;
  }

  function buildItems(ids) {
    return ids.map(function (id) {
      return { id: id, quantity: 1 };
    });
  }

  function clearAddonSelections(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('.addon_add:checked').forEach(function (el) {
      el.checked = false;
    });

    scope.querySelectorAll('.variant-list-container[data-selected]').forEach(function (el) {
      el.removeAttribute('data-selected');
      var sel = el.querySelector('select.variant-select');
      if (!sel) return;
      for (var i = 0; i < sel.options.length; i++) {
        sel.options[i].removeAttribute('data-selected');
      }
      sel.selectedIndex = 0;
    });
  }

  function postAddonItems(items) {
    if (!items.length) return Promise.resolve();

    return fetch(cartAddJsUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (text) {
          console.warn('[addons-cart] cart/add.js failed', res.status, text);
        });
      }
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
    }).catch(function (e) {
      console.warn('[addons-cart]', e);
    });
  }

  function scopeFromVariantAddEvent(event) {
    var t = event.target;
    if (!t || !t.closest) return document;
    var form = t.tagName === 'FORM' && t.getAttribute('action') && t.getAttribute('action').indexOf('/cart/add') !== -1
      ? t
      : t.closest('form[action*="/cart/add"]');
    if (!form) return document;
    var scope = form.closest('.product-info') || form.closest('product-rerender');
    return scope || document;
  }

  function scopeForProductAdded() {
    if (document.body && document.body.classList.contains('template-product')) {
      var info = document.querySelector('.product-info');
      if (info) return info;
    }
    return document;
  }

  function runForScope(scope) {
    var ids = collectAddonVariantIds(scope);
    var items = buildItems(ids);
    if (!items.length) return;
    return postAddonItems(items).then(function () {
      clearAddonSelections(scope);
    });
  }

  document.addEventListener(
    'variant:add',
    function (event) {
      var scope = scopeFromVariantAddEvent(event);
      void runForScope(scope);
    },
    false
  );

  document.addEventListener(
    'product:added',
    function () {
      var scope = scopeForProductAdded();
      void runForScope(scope);
    },
    false
  );
})();
